import React, { useState } from "react"
import { Tooltip } from "reactstrap";

export const InfoTip = ({ children, roleId="info-icon" }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

    return (<>
        <span className="ms-2"><img src="https://static.sibilus.eu/gfx/info-i-icon-0.svg" id={roleId} alt="info-icon" style={{width: "20px"}} /></span>
        <Tooltip
            target={roleId}
            isOpen={tooltipOpen}
            toggle={toggleTooltip}
        >
            {children}
        </Tooltip>
    </>)
} 
